import React, {useEffect, useState } from 'react';
import {getFirestore, doc, getDoc } from 'firebase/firestore';
import Hw3ItemDetail from '../Hw3ItemDetail';
import { useParams } from 'react-router-dom';

// 1 traer el servicio de firestore
// 2 Crear un puntero al dato que queremos
// 3 traer el dato con una promesa

export const Hw3ItemDetailContainer = () => {
    const [data, setData] = useState({});
    const { detalleId } =useParams();

    useEffect(() => {
        const querydb = getFirestore();
        const queryDoc = doc(querydb, 'products', detalleId);
        getDoc(queryDoc)
            .then(res => setData({ id: res.id, ...res.data() }))
    }, [detalleId])

    return (
        <Hw3ItemDetail data={data} />
    );
}

export default Hw3ItemDetailContainer;